export enum FileTypeEnum {
  COVER = 'COVER',
  LOGO = 'LOGO',
  ITEM_IMAGE = 'ITEM_IMAGE'
}
